import React from 'react';
export function StarIcon({className='w-5 h-5'}) { return <img src="/star.png" alt="" aria-hidden="true" className={`inline-block object-contain shrink-0 ${className}`} />; }
export default function Stars({value}) { return <span className="inline-flex items-center gap-1.5"><StarIcon />{Number(value||0).toLocaleString('ru-RU')} старсов</span>; }
